import React from 'react'
import { Box } from '@material-ui/core'
import AppBar from './components/app-bar'
import NotFoundImage from './images/404.jpg'

const NotFound = () => {

  return (
    <AppBar>
      <Box id="coming-soon" style={{ 
       background: 'white',
        backgroundImage: `url(${NotFoundImage})`, backgroundSize: '50%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', width: '100%' }} />
    </AppBar>
  )
}


NotFound.propTypes = {}

export default NotFound